// Format duration from minutes into appropriate units
export function formatDuration(minutes: number): string {
  if (!minutes) return '0 min';

  const days = Math.floor(minutes / 1440); // 1440 = 24 * 60
  const hours = Math.floor((minutes % 1440) / 60);
  const remainingMinutes = minutes % 60;

  if (days > 0) {
    if (hours > 0) {
      return `${days} day${days > 1 ? 's' : ''}, ${hours} hour${hours > 1 ? 's' : ''}`;
    }
    return `${days} day${days > 1 ? 's' : ''}`;
  }

  if (hours > 0) {
    if (remainingMinutes > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''}, ${remainingMinutes} min`;
    }
    return `${hours} hour${hours > 1 ? 's' : ''}`;
  }

  return `${minutes} min`;
}